
import moment from "moment";

export const DateRangeValidation = (data, key, val) => {
  const momentDate = (date) => {
    return moment(new Date(date)).format("MM/DD/YYYY");
  };

  let getDate = data.toString().split("Q");
  let quarterCount = Number(getDate[0]);
  let year = Number(getDate[1]);
  let date;
  if (key === "toDate") {
    date = (quarterCount === 1 && "03") ||
      (quarterCount === 2 && "06") ||
      (quarterCount === 3 && "09") ||
      (quarterCount === 4 && "12");
  } else {
    date = (quarterCount === 1 && "01") ||
      (quarterCount === 2 && "04") ||
      (quarterCount === 3 && "07") ||
      (quarterCount === 4 && "10");
  }

  if (key === "toDate") {
    let lastDate = new Date(Number(year), Number(date), 0).getDate();
    if (val) {
      return momentDate(`${date}/${lastDate}/${year}`);
    }
    return momentDate(`${date}/${lastDate}/${"20" + year}`);
  } else {
    if (val) {
      return momentDate(`${date}/01/${year}`);
    }
    return momentDate(`${date}/01/${"20" + year}`);
  }
  //   };
};

